<div class="card main-store-card container-fluid">
  
  <!-- Header: Titulo y Botón Volver -->
  <div class="row justify-content-between align-items-center mb-4">
    <div class="col-auto">
      <h3 class="m-0 font-bold text-muted">Editar Mi Negocio</h3>
    </div>
    <div class="col-auto">
      <p-button
        label="Volver"
        icon="pi pi-arrow-left"
        (onClick)="cancel()"
        severity="secondary"
        [rounded]="true"
        size="small"
      />
    </div>
  </div>

  @if (storeInfo) {
    <!-- Banner Principal -->
    <div class="store-banner"></div>

    <!-- Perfil Superpuesto -->
    <div class="store-profile-header">
      <div class="logo-container">
        @if (storeInfo.sto_logo_url) {
          <img src="{{ storeInfo.sto_logo_url }}" alt="Logo" class="store-logo-img" />
        } @else {
          <div class="store-logo-placeholder">
            {{ storeInfo.sto_name.slice(0, 2) }}
          </div>
        }
      </div>
      
      <div class="store-meta-info">
        <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
          <h2 class="store-title m-0">{{ storeInfo.sto_name }}</h2>
          <span class="status-badge status-open">
            Modo Edición
          </span>
        </div>
        <p class="store-description m-0">{{ storeInfo.sto_description || 'Sin descripción disponible' }}</p>
      </div>
    </div>

    <!-- Layout de Columnas -->
    <div class="container-fluid p-0 mt-4">
      <div class="row">
        
        <!-- Columna Izquierda: Formularios y Horarios -->
        <div class="col-lg-8 mb-4">
          
          <!-- Tarjeta: Información Básica -->
          <div class="detail-card">
            <div class="detail-card-title">
              <i class="pi pi-info-circle"></i> Información Básica
            </div>
            
            <form [formGroup]="formStore" class="mt-2">
              <div class="row">
                <!-- Nombre de la tienda -->
                <div class="col-md-6 mb-3">
                  <label for="sto_name" class="form-label-edit d-block mb-2">Nombre del Negocio *</label>
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="pi pi-shop"></i>
                    </span>
                    <input
                      id="sto_name"
                      type="text"
                      pInputText
                      formControlName="sto_name"
                      placeholder="Nombre comercial"
                      class="largeInput"
                    />
                  </div>
                  @if (
                    formStore.controls['sto_name'].hasError('required') &&
                    formStore.controls['sto_name'].touched
                  ) {
                    <span class="text-danger labelError">
                      <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                    </span>
                  }
                </div>

                <!-- Teléfono de la tienda -->
                <div class="col-md-6 mb-3">
                  <label for="sto_phone" class="form-label-edit d-block mb-2">Teléfono de Contacto *</label>
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="pi pi-phone"></i>
                    </span>
                    <input
                      id="sto_phone"
                      type="text"
                      pInputText
                      formControlName="sto_phone"
                      placeholder="Teléfono de contacto"
                      class="largeInput"
                    />
                  </div>
                  @if (
                    formStore.controls['sto_phone'].hasError('required') &&
                    formStore.controls['sto_phone'].touched
                  ) {
                    <span class="text-danger labelError">
                      <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                    </span>
                  }
                </div>
              </div>

              <!-- Descripción comercial -->
              <div class="row">
                <div class="col-12 mb-2">
                  <label for="sto_description" class="form-label-edit d-block mb-2">Descripción Comercial</label>
                  <textarea
                    id="sto_description"
                    pInputTextarea
                    formControlName="sto_description"
                    rows="3"
                    placeholder="Breve descripción del negocio..."
                    class="largeInput"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>

          <!-- Tarjeta: Ubicación y Parámetros Comerciales -->
          <div class="detail-card">
            <div class="detail-card-title">
              <i class="pi pi-map-marker"></i> Ubicación y Parámetros Comerciales
            </div>
            
            <div class="row g-4 mt-2">
              <!-- Columna izquierda: Formulario de ubicación -->
              <div class="col-xl-5">
                <form [formGroup]="formLocation">
                  
                  <!-- Dirección de la tienda -->
                  <div class="mb-3">
                    <label for="myStoreAddressInput" class="form-label-edit d-block mb-2">Dirección del Negocio *</label>
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon">
                        <i class="pi pi-compass"></i>
                      </span>
                      <input
                        id="myStoreAddressInput"
                        type="text"
                        pInputText
                        formControlName="sto_address"
                        placeholder="Buscar dirección..."
                        autocomplete="off"
                        class="largeInput"
                      />
                    </div>
                    @if (
                      formLocation.controls['sto_address'].hasError('required') &&
                      formLocation.controls['sto_address'].touched
                    ) {
                      <span class="text-danger labelError">
                        <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                      </span>
                    }
                  </div>

                  <!-- Radio de Entrega -->
                  <div class="mb-3">
                    <label for="sto_delivery_radius_km" class="form-label-edit d-block mb-2">Radio de Entrega (km) *</label>
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon">
                        <i class="pi pi-map"></i>
                      </span>
                      <p-inputNumber
                        id="sto_delivery_radius_km"
                        formControlName="sto_delivery_radius_km"
                        mode="decimal"
                        [min]="0"
                        placeholder="Radio en kilómetros"
                        class="largeInput"
                        styleClass="w-100"
                      />
                    </div>
                  </div>

                  <!-- Pedido Mínimo -->
                  <div class="mb-3">
                    <label for="sto_min_order_amount" class="form-label-edit d-block mb-2">Monto de Pedido Mínimo ($) *</label>
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon">
                        <i class="pi pi-shopping-bag"></i>
                      </span>
                      <input
                        id="sto_min_order_amount"
                        type="text"
                        inputmode="numeric"
                        pInputText
                        appCentsCurrencyInput
                        formControlName="sto_min_order_amount"
                        placeholder="0,00"
                        class="largeInput"
                      />
                    </div>
                  </div>

                </form>
              </div>

              <!-- Columna derecha: Mapa -->
              <div class="col-xl-7">
                <label class="form-label-edit d-block mb-2">Ubicación Geográfica (Arrastre el marcador)</label>
                <div class="map-container">
                  <google-map
                    [center]="mapCenter"
                    [zoom]="mapZoom"
                    [options]="mapOptions"
                    height="100%"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Tarjeta: Horarios de Funcionamiento -->
          <div class="detail-card">
            <div class="detail-card-title mb-3">
              <i class="pi pi-clock"></i> Horarios de Funcionamiento
            </div>
            
            <p-table [value]="ltsSchedules" styleClass="p-datatable-sm p-datatable-striped">
              <ng-template pTemplate="header">
                <tr>
                  <th id="idday" style="width: 25%">Día</th>
                  <th id="isOpen" style="width: 25%">Abierto</th>
                  <th id="openTime" style="width: 25%">Hora Apertura</th>
                  <th id="closeTime" style="width: 25%">Hora Cierre</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-schedule>
                <tr>
                  <td class="font-bold">{{ getDayName(schedule.ssh_day_of_week) }}</td>
                  <td>
                    <p-toggleButton
                      [(ngModel)]="schedule.ssh_is_open"
                      onLabel="Sí"
                      offLabel="No"
                      [style]="{ width: '100%', 'max-width': '120px' }"
                    />
                  </td>
                  <td>
                    <div class="p-inputgroup" [ngClass]="{'opacity-50': !schedule.ssh_is_open}">
                      <span class="p-inputgroup-addon">
                        <i class="pi pi-clock"></i>
                      </span>
                      <p-calendar
                        [(ngModel)]="schedule.ssh_open_time"
                        [timeOnly]="true"
                        hourFormat="24"
                        [disabled]="!schedule.ssh_is_open"
                        styleClass="w-100"
                      />
                    </div>
                  </td>
                  <td>
                    <div class="p-inputgroup" [ngClass]="{'opacity-50': !schedule.ssh_is_open}">
                      <span class="p-inputgroup-addon">
                        <i class="pi pi-clock"></i>
                      </span>
                      <p-calendar
                        [(ngModel)]="schedule.ssh_close_time"
                        [timeOnly]="true"
                        hourFormat="24"
                        [disabled]="!schedule.ssh_is_open"
                        styleClass="w-100"
                      />
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <!-- Columna Derecha: Panel de Guardar y Logo -->
        <div class="col-lg-4 mb-4">
          
          <!-- Tarjeta: Acciones de Guardado -->
          <div class="detail-card position-sticky" style="top: 2rem; z-index: 20;">
            <div class="detail-card-title">
              <i class="pi pi-save"></i> Guardar Cambios
            </div>
            <p class="text-muted small mb-4">Asegúrese de completar todos los campos requeridos (*) antes de guardar la información.</p>
            
            <div class="d-flex flex-column gap-3">
              <p-button
                label="Guardar"
                icon="pi pi-save"
                severity="success"
                [rounded]="true"
                [loading]="loading"
                [disabled]="formStore.invalid || formLocation.invalid"
                (onClick)="save()"
                styleClass="w-100 p-button-success"
              />
              <p-button
                label="Cancelar"
                icon="pi pi-times"
                severity="secondary"
                [rounded]="true"
                (onClick)="cancel()"
                styleClass="w-100"
              />
            </div>
          </div>

          <!-- Tarjeta: Gestión de Logo -->
          <div class="detail-card">
            <div class="detail-card-title">
              <i class="pi pi-image"></i> Gestión de Logo
            </div>
            
            <div class="d-flex justify-content-center mb-3">
              <p-fileUpload
                #fileUpload
                mode="basic"
                chooseLabel="Seleccionar Imagen"
                chooseIcon="pi pi-upload"
                [showUploadButton]="false"
                [showCancelButton]="false"
                maxFileSize="5000000"
                (onSelect)="onUploadLogo($event.files, fileUpload)"
                accept="image/*"
                [multiple]="false"
                styleClass="p-button-outlined w-100"
              />
            </div>

            <div class="text-center py-3 border rounded bg-light">
              @if (logoPreview) {
                <div class="mb-2">
                  <span class="info-label d-block mb-2 font-bold">Nueva Imagen (sin guardar)</span>
                  <p-image [src]="logoPreview" alt="Logo" width="120" styleClass="shadow-sm rounded border" />
                  <div class="mt-2">
                    <p-button
                      label="Descartar"
                      icon="pi pi-times"
                      severity="danger"
                      [rounded]="true"
                      size="small"
                      (onClick)="removeFile()"
                    />
                  </div>
                </div>
              } @else if (storeInfo.sto_logo_url) {
                <div class="mb-2">
                  <span class="info-label d-block mb-2 font-bold">Logo Actual</span>
                  <p-image [src]="storeInfo.sto_logo_url" alt="Logo" width="120" styleClass="shadow-sm rounded border" />
                </div>
              } @else {
                <div class="d-flex flex-column align-items-center py-3">
                  <i class="pi pi-image text-muted mb-2" style="font-size: 2.5rem;"></i>
                  <p class="text-muted small m-0">Sin logo asignado</p>
                </div>
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  } @else if (loading) {
    <div class="d-flex flex-column align-items-center justify-content-center py-5">
      <i class="pi pi-spin pi-spinner text-primary mb-3" style="font-size: 3rem"></i>
      <p class="text-muted font-bold">Cargando información del negocio...</p>
    </div>
  } @else {
    <div class="d-flex flex-column align-items-center justify-content-center py-5">
      <i class="pi pi-exclamation-triangle text-danger mb-3" style="font-size: 3rem"></i>
      <p class="text-muted font-bold">{{ errorMessage }}</p>
      <p-button label="Reintentar" icon="pi pi-refresh" (onClick)="getStore()" [rounded]="true" size="small" />
    </div>
  }
</div>
